<div class="public-table-page">

  <!-- ==================================================
       LOADING
       ================================================== -->

  <div
    class="loading-container"
    *ngIf="loading"
  >

    <div class="spinner"></div>

    <p>
      Carregando cardápio...
    </p>

  </div>


  <!-- ==================================================
       ERRO
       ================================================== -->

  <div
    class="error-page"
    *ngIf="
      !loading &&
      !data &&
      errorMessage
    "
  >

    <div class="error-icon">
      !
    </div>


    <h1>
      Não foi possível abrir a mesa
    </h1>


    <p>
      {{ errorMessage }}
    </p>


    <button
      type="button"
      class="primary-button"
      (click)="loadTable()"
    >
      Tentar novamente
    </button>

  </div>


  <!-- ==================================================
       CONTEÚDO
       ================================================== -->

  <ng-container
    *ngIf="
      !loading &&
      data
    "
  >

    <!-- HEADER -->

    <header class="restaurant-header">

      <div>

        <span class="restaurant-label">
          Cardápio digital
        </span>


        <h1>
          {{ data.restaurant.name }}
        </h1>


        <p>

          {{ data.table.name }}

          <ng-container
            *ngIf="
              data.table.area
            "
          >
            · {{ data.table.area }}
          </ng-container>

        </p>

      </div>


      <div
        class="session-status"
        [class.bill-requested]="
          data.session?.status ===
          'BILL_REQUESTED'
        "
        [class.awaiting-payment]="
          data.session?.status ===
          'AWAITING_PAYMENT'
        "
        [class.no-session]="
          !hasActiveSession
        "
      >
        {{ sessionStatusLabel }}
      </div>

    </header>


    <main class="page-content">

      <!-- ==================================================
           MENSAGENS
           ================================================== -->

      <div
        class="message success-message"
        *ngIf="
          successMessage
        "
      >
        {{ successMessage }}
      </div>


      <div
        class="message error-message"
        *ngIf="
          errorMessage
        "
      >
        {{ errorMessage }}
      </div>


      <!-- ==================================================
           ATENDIMENTO DA MESA
           ================================================== -->

      <section class="table-assistance">

        <div class="assistance-information">

          <span class="assistance-label">
            SUA MESA
          </span>


          <h2>
            {{ data.table.name }}
          </h2>


          <p
            *ngIf="
              !hasActiveSession
            "
          >
            Você já pode conhecer nosso cardápio.
            Quando quiser fazer seu pedido,
            solicite a abertura da comanda.
          </p>


          <p
            *ngIf="
              hasActiveSession
            "
          >
            Sua comanda está aberta.
            Faça seus pedidos pelo cardápio
            ou solicite atendimento.
          </p>

        </div>


        <div class="assistance-actions">

          <!-- SOLICITAR ABERTURA -->

          <button
            type="button"
            class="open-session-request-button"
            *ngIf="
              !hasActiveSession
            "
            [class.requested]="
              openSessionRequested
            "
            [disabled]="
              sendingOpenSessionRequest ||
              openSessionRequested
            "
            (click)="
              requestOpenSession()
            "
          >

            <span class="assistance-action-icon">
              {{
                openSessionRequested
                  ? '✓'
                  : '🙋'
              }}
            </span>


            <span>

              <strong>
                {{
                  openSessionRequested
                    ? 'Solicitação enviada'
                    : 'Quero fazer um pedido'
                }}
              </strong>

              <small>
                {{
                  sendingOpenSessionRequest
                    ? 'Enviando solicitação...'
                    : openSessionRequested
                      ? 'Aguarde um atendente'
                      : 'Solicitar abertura da comanda'
                }}
              </small>

            </span>

          </button>


          <!-- CHAMAR GARÇOM -->

          <button
            type="button"
            class="waiter-request-button"
            [class.requested]="
              waiterRequested
            "
            [disabled]="
              sendingWaiterRequest ||
              waiterRequested
            "
            (click)="
              requestWaiter()
            "
          >

            <span class="assistance-action-icon">
              {{
                waiterRequested
                  ? '✓'
                  : '🔔'
              }}
            </span>


            <span>

              <strong>
                {{
                  waiterRequested
                    ? 'Garçom chamado'
                    : 'Chamar garçom'
                }}
              </strong>


              <small>
                {{
                  sendingWaiterRequest
                    ? 'Chamando...'
                    : waiterRequested
                      ? 'Aguarde um momento'
                      : 'Preciso de atendimento'
                }}
              </small>

            </span>

          </button>

        </div>

      </section>


      <!-- ==================================================
           RESUMO DA COMANDA
           ================================================== -->

      <section
        class="summary-card"
        *ngIf="
          hasActiveSession
        "
      >

        <div>

          <span>
            Total da comanda
          </span>


          <strong>
            {{
              data.session
                ?.summary
                ?.total ||
                0
                | currency:
                  'BRL':
                  'symbol':
                  '1.2-2':
                  'pt-BR'
            }}
          </strong>

        </div>


        <div>

          <span>
            Pedidos
          </span>


          <strong>
            {{ sessionOrders.length }}
          </strong>

        </div>

      </section>


      <!-- ==================================================
           BUSCA
           SEMPRE DISPONÍVEL
           ================================================== -->

      <section class="search-section">

        <div class="search-title">

          <span>
            🍽️
          </span>

          <div>

            <strong>
              Explore nosso cardápio
            </strong>

            <small
              *ngIf="
                !hasActiveSession
              "
            >
              Você pode visualizar todos os produtos
              enquanto aguarda sua comanda.
            </small>

          </div>

        </div>


        <input
          type="search"
          [(ngModel)]="
            searchText
          "
          (ngModelChange)="
            filterProducts()
          "
          placeholder="Buscar no cardápio..."
          aria-label="Buscar produtos"
        >

      </section>


      <!-- ==================================================
           CARDÁPIO
           SEMPRE VISÍVEL
           ================================================== -->

      <section class="products-section">

        <div class="section-title">

          <div>

            <span>
              Cardápio
            </span>

            <h2>
              Escolha seus produtos
            </h2>

          </div>

        </div>


        <!-- AVISO SEM COMANDA -->

        <div
          class="menu-preview-notice"
          *ngIf="
            !hasActiveSession
          "
        >

          <span>
            👀
          </span>


          <div>

            <strong>
              Você está visualizando o cardápio
            </strong>

            <p>
              Para adicionar produtos e enviar pedidos,
              solicite a abertura da sua comanda.
            </p>

          </div>


          <button
            type="button"
            *ngIf="
              !openSessionRequested
            "
            [disabled]="
              sendingOpenSessionRequest
            "
            (click)="
              requestOpenSession()
            "
          >
            {{
              sendingOpenSessionRequest
                ? 'Solicitando...'
                : 'Solicitar comanda'
            }}
          </button>

        </div>


        <!-- SEM PRODUTOS -->

        <div
          class="empty-products"
          *ngIf="
            filteredProducts.length ===
            0
          "
        >
          Nenhum produto encontrado.
        </div>


        <!-- PRODUTOS -->

        <div class="products-grid">

          <article
            class="product-card"
            *ngFor="
              let product
              of filteredProducts;
              trackBy:
                trackProductById
            "
          >

            <!-- IMAGEM -->

            <div
              class="product-image"
              *ngIf="
                product.imageUrl
              "
            >

              <img
                [src]="
                  product.imageUrl
                "
                [alt]="
                  product.name
                "
              >

            </div>


            <div
              class="
                product-image
                placeholder
              "
              *ngIf="
                !product.imageUrl
              "
            >
              🍴
            </div>


            <!-- CONTEÚDO -->

            <div class="product-content">

              <div class="product-information">

                <h3>
                  {{ product.name }}
                </h3>


                <p
                  *ngIf="
                    product.description
                  "
                >
                  {{ product.description }}
                </p>

              </div>


              <div class="product-footer">

                <strong>
                  {{
                    toNumber(
                      product.price
                    )
                      | currency:
                        'BRL':
                        'symbol':
                        '1.2-2':
                        'pt-BR'
                  }}
                </strong>


                <button
                  type="button"
                  class="add-button"
                  [class.preview-button]="
                    !canOrder
                  "
                  [disabled]="
                    !canOrder
                  "
                  (click)="
                    addToCart(
                      product
                    )
                  "
                >

                  {{
                    canOrder
                      ? 'Adicionar'
                      : 'Aguardando comanda'
                  }}

                </button>

              </div>

            </div>

          </article>

        </div>

      </section>


      <!-- ==================================================
           DAQUI PARA BAIXO
           SOMENTE COM COMANDA
           ================================================== -->

      <ng-container
        *ngIf="
          hasActiveSession
        "
      >

        <!-- MEUS PEDIDOS -->

        <section class="orders-section">

          <button
            type="button"
            class="section-toggle"
            (click)="
              showOrders =
                !showOrders
            "
          >

            <span>

              Meus pedidos

              <small>
                {{ sessionOrders.length }}
              </small>

            </span>


            <span>
              {{
                showOrders
                  ? '−'
                  : '+'
              }}
            </span>

          </button>


          <div
            class="orders-list"
            *ngIf="
              showOrders
            "
          >

            <p
              class="empty-orders"
              *ngIf="
                sessionOrders.length ===
                0
              "
            >
              Ainda não existem pedidos nesta comanda.
            </p>


            <article
              class="order-card"
              *ngFor="
                let order
                of sessionOrders
              "
            >

              <div class="order-header">

                <div>

                  <strong>
                    Pedido #{{ order.id }}
                  </strong>


                  <span>
                    {{
                      order.createdAt
                        | date:
                          'dd/MM/yyyy HH:mm'
                    }}
                  </span>

                </div>


                <span
                  class="order-status"
                  [attr.data-status]="
                    order.status
                  "
                >
                  {{
                    getOrderStatusLabel(
                      order.status
                    )
                  }}
                </span>

              </div>


              <div class="order-items">

                <div
                  class="order-item"
                  *ngFor="
                    let item
                    of order.items
                  "
                >

                  <span>

                    {{ item.quantity }}×

                    {{
                      item.product
                        ?.name ||
                      'Produto'
                    }}

                  </span>


                  <strong>
                    {{
                      toNumber(
                        item.total
                      )
                        | currency:
                          'BRL':
                          'symbol':
                          '1.2-2':
                          'pt-BR'
                    }}
                  </strong>

                </div>

              </div>


              <div class="order-total">

                <span>
                  Total
                </span>


                <strong>
                  {{
                    toNumber(
                      order.total
                    )
                      | currency:
                        'BRL':
                        'symbol':
                        '1.2-2':
                        'pt-BR'
                  }}
                </strong>

              </div>

            </article>

          </div>

        </section>


        <!-- ==================================================
             SOLICITAR CONTA
             ================================================== -->

        <section class="bill-section">

          <div>

            <span>
              Terminou seu pedido?
            </span>


            <h2>
              Solicitar a conta
            </h2>


            <p>
              Depois de solicitar a conta,
              novos pedidos serão bloqueados.
            </p>

          </div>


          <button
            type="button"
            class="bill-button"
            [disabled]="
              !canRequestBill ||
              requestingBill
            "
            (click)="
              requestBill()
            "
          >
            {{
              requestingBill
                ? 'Solicitando...'
                : 'Solicitar conta'
            }}
          </button>

        </section>

      </ng-container>

    </main>


    <!-- ==================================================
         CARRINHO FLUTUANTE
         ================================================== -->

    <button
      type="button"
      class="floating-cart"
      *ngIf="
        cartItemsCount >
        0
      "
      (click)="
        showCart =
          true
      "
    >

      <span class="cart-icon">
        🛒
      </span>


      <span>

        Ver pedido

        <small>
          {{ cartItemsCount }}

          {{
            cartItemsCount === 1
              ? 'item'
              : 'itens'
          }}
        </small>

      </span>


      <strong>
        {{
          cartSubtotal
            | currency:
              'BRL':
              'symbol':
              '1.2-2':
              'pt-BR'
        }}
      </strong>

    </button>


    <!-- ==================================================
         OVERLAY
         ================================================== -->

    <div
      class="cart-overlay"
      *ngIf="
        showCart
      "
      (click)="
        showCart =
          false
      "
    ></div>


    <!-- ==================================================
         CARRINHO
         ================================================== -->

    <aside
      class="cart-drawer"
      [class.open]="
        showCart
      "
    >

      <div class="cart-header">

        <div>

          <span>
            Seu pedido
          </span>


          <h2>
            Carrinho
          </h2>

        </div>


        <button
          type="button"
          class="close-button"
          aria-label="Fechar carrinho"
          (click)="
            showCart =
              false
          "
        >
          ×
        </button>

      </div>


      <div
        class="empty-cart"
        *ngIf="
          cart.length ===
          0
        "
      >
        Seu carrinho está vazio.
      </div>


      <div
        class="cart-content"
        *ngIf="
          cart.length >
          0
        "
      >

        <article
          class="cart-item"
          *ngFor="
            let item
            of cart;
            trackBy:
              trackCartItemByProductId
          "
        >

          <div class="cart-item-top">

            <div>

              <h3>
                {{ item.product.name }}
              </h3>


              <strong>
                {{
                  toNumber(
                    item.product.price
                  ) *
                  item.quantity
                    | currency:
                      'BRL':
                      'symbol':
                      '1.2-2':
                      'pt-BR'
                }}
              </strong>

            </div>


            <button
              type="button"
              class="remove-button"
              (click)="
                removeFromCart(
                  item.product.id
                )
              "
            >
              Remover
            </button>

          </div>


          <div class="quantity-control">

            <button
              type="button"
              (click)="
                decreaseQuantity(
                  item
                )
              "
            >
              −
            </button>


            <span>
              {{ item.quantity }}
            </span>


            <button
              type="button"
              (click)="
                increaseQuantity(
                  item
                )
              "
            >
              +
            </button>

          </div>


          <input
            type="text"
            [(ngModel)]="
              item.notes
            "
            maxlength="500"
            placeholder="Observação do item"
          >

        </article>


        <!-- CLIENTE -->

        <div class="customer-fields">

          <label>

            Seu nome

            <input
              type="text"
              [(ngModel)]="
                customerName
              "
              maxlength="150"
              placeholder="Como podemos chamar você?"
            >

          </label>


          <label>

            Telefone

            <input
              type="tel"
              [(ngModel)]="
                customerPhone
              "
              maxlength="30"
              placeholder="Telefone opcional"
            >

          </label>


          <label>

            Observação do pedido

            <textarea
              [(ngModel)]="
                orderNotes
              "
              maxlength="1000"
              rows="3"
              placeholder="Exemplo: entregar tudo junto"
            ></textarea>

          </label>

        </div>


        <!-- TOTAL -->

        <div class="cart-summary">

          <span>
            Subtotal
          </span>


          <strong>
            {{
              cartSubtotal
                | currency:
                  'BRL':
                  'symbol':
                  '1.2-2':
                  'pt-BR'
            }}
          </strong>

        </div>


        <button
          type="button"
          class="send-order-button"
          [disabled]="
            sendingOrder ||
            !canOrder
          "
          (click)="
            sendOrder()
          "
        >
          {{
            sendingOrder
              ? 'Enviando pedido...'
              : 'Enviar pedido'
          }}
        </button>

      </div>

    </aside>

  </ng-container>

</div>